import { render, staticRenderFns } from "./CosmicVelocityViz.vue?vue&type=template&id=e0b2a268&scoped=true"
import script from "./CosmicVelocityViz.vue?vue&type=script&lang=js"
export * from "./CosmicVelocityViz.vue?vue&type=script&lang=js"
import style0 from "./CosmicVelocityViz.vue?vue&type=style&index=0&id=e0b2a268&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b2a268",
  null
  
)

export default component.exports